<main>
  <ng-template #dynamicLayoutCmp></ng-template>
</main>
